import { lookupListAsRecordObject } from '@utils/graph-utils';
export function LookupToList(data: any) {
  const accountEnums: Record<string, Record<string, string>> = {};
  accountEnums['Type'] = lookupListAsRecordObject(
    data.Accounting.lookups.accountType
  );

  return accountEnums;
}
